class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    // 🌟 1. 配置防抖延迟参数（可根据手感自定）
    this.CLOSE_DELAY = 250; // 鼠标移出后的缓冲时间(ms)，给用户足够的移动轨迹容错
    this.OPEN_DELAY = 80;    // 鼠标扫过时的开启防抖时间(ms)，防止快速划过误触发
    
    this.closeTimer = null;
    this.openTimer = null;

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  // 统一清理定时器
  clearTimers() {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
    if (this.openTimer) {
      clearTimeout(this.openTimer);
      this.openTimer = null;
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  onMouseEnter() {
    if (window.innerWidth <= 750) return; // 移动端跳过 hover

    // 🌟 2. 移入时立即清理关闭计划（救回即将关闭的菜单）
    this.clearTimers();

    // 如果菜单已经处于 Hover 状态，直接保持，无需重新设置
    if (this.mainDetailsToggle.classList.contains('is-hovered') && this.mainDetailsToggle.hasAttribute('open')) {
      return;
    }

    // 移入防抖：防止鼠标快速划过导航时误打开
    this.openTimer = setTimeout(() => {
      document.body.classList.add('menu-active-blur');
      this.mainDetailsToggle.classList.remove('is-leaving');
      this.mainDetailsToggle.classList.add('is-hovered');
      this.mainDetailsToggle.setAttribute('open', '');
    }, this.OPEN_DELAY);
  }

  onMouseLeave(event) {
    if (window.innerWidth <= 750) return;

    // 检查鼠标移动的新目标是否仍然在当前组件内部
    if (this.contains(event.relatedTarget)) return;

    // 如果还没有触发打开，又移出了，直接取消打开计划
    if (this.openTimer) {
      clearTimeout(this.openTimer);
      this.openTimer = null;
    }

    // 🌟 3. 核心修复：在 CLOSE_DELAY (250ms) 缓冲期内，不移除任何类名！
    this.closeTimer = setTimeout(() => {
      // 倒计时结束，用户确实没有再回移鼠标，此时才开始淡出离场
      this.mainDetailsToggle.classList.remove('is-hovered');
      this.mainDetailsToggle.classList.add('is-leaving');
      document.body.classList.remove('menu-active-blur');

      // 配合 CSS 退场过渡动画时长 (如 200ms) 后彻底销毁 open 属性
      setTimeout(() => {
        if (!this.mainDetailsToggle.classList.contains('is-hovered')) {
          this.mainDetailsToggle.removeAttribute('open');
          this.mainDetailsToggle.classList.remove('is-leaving');
        }
      }, 200);

      this.closeTimer = null;
    }, this.CLOSE_DELAY);
  }

  close() {
    this.clearTimers();
    this.mainDetailsToggle.classList.remove('is-hovered', 'is-leaving');
    this.mainDetailsToggle.removeAttribute('open');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-active-blur', 'body-menu-open');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);